module.exports = __webpack_public_path__ + "img/ws.50f10b10.png";